import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IPackageResponse, IPackageState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowPackage = createAsyncThunk(
  'listPackages/fetchShowPackage',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.package(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IPackageState = {
  isLoading: false,
  response: null,
  error: null
}

const showPackageSlice = createSlice({
  name: 'packages/show',
  initialState,
  reducers: {
    resetShowPackage: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowPackage.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowPackage.fulfilled, (state, action: PayloadAction<IPackageResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowPackage.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showPackageSlice.reducer
export const { resetShowPackage } = showPackageSlice.actions
